module.exports = __webpack_public_path__ + "static/img/yoga26.4ad89ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fc/yoga26.png
// module id = 74VV
// module chunks = 0